import HoverAuthorizeTooltip from "components/authorize/AuthorizeTooltip";
import { EditDropdownLink } from "components/dashboard/update";
import { DownloadChartModal } from "components/modals/DownloadChartModal";
import DefaultModal from "components/modals/ModalTemplate";
import { CHART_DELETE_SUCCESS_MESSAGE, DELETE_CHART_MESSAGE } from "constant";
import { walletModalTrigger } from "hooks/wallet";
import { useCallback, useState } from "react";
import { Dropdown } from "react-bootstrap";
import dashboardService from "service/dashboardService";
import { getAPIError, showErrorAlert, showSuccessAlert } from "utils/alert";
import { isHttpSuccess } from "utils/functions";
import { DownloadConsumptionChartModal } from "./DownloadConsumptionChartModal";
import { ChartType } from "constant/chart";

const ChartActionDropdown = ({
    panelId,
    dashboardId,
    onDelete,
    panel,
    deviceConfig,
    onDownload,
}: any) => {
    const { chart } = panel;

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const closeDownloadModal = useCallback(() => {
        setShowDownloadModal(false);
    }, []);

    const onClickDownload = () => {
        walletModalTrigger(() => {
            onDownload?.();
            !onDownload && setShowDownloadModal(true);
        });
    };

    const handleDeletePanel = async () => {
        try {
            const deletePanelRes = await dashboardService.deletePanel(
                dashboardId,
                panelId
            );
            if (isHttpSuccess(deletePanelRes.status)) {
                onDelete(dashboardId);
                showSuccessAlert({
                    message: CHART_DELETE_SUCCESS_MESSAGE,
                });
                setShowDeleteModal(false);
            } else {
                showErrorAlert(
                    getAPIError(
                        deletePanelRes,
                        "Unable to delete panel. Please try again."
                    )
                );
            }
        } catch (err) {
            console.error(err);
        }
    };

    const DownloadModal = [ChartType.BAR, ChartType.STACKED_BAR].includes(chart) ? DownloadConsumptionChartModal : DownloadChartModal;

    return (
        <>
            <Dropdown alignRight>
                <Dropdown.Toggle variant="" className="more-icon">
                    <i className="material-icons">more_vert</i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <HoverAuthorizeTooltip permission="dashboard:update">
                        <EditDropdownLink panelId={panelId} />
                    </HoverAuthorizeTooltip>
                    <HoverAuthorizeTooltip permission="dashboard:delete">
                        <Dropdown.Item
                            onClick={() => {
                                setShowDeleteModal(true);
                            }}
                        >
                            Delete
                        </Dropdown.Item>
                    </HoverAuthorizeTooltip>
                    {deviceConfig && (
                        <HoverAuthorizeTooltip permission="gateway:update">
                            <Dropdown.Item onClick={onClickDownload}>
                                Download Data
                            </Dropdown.Item>
                        </HoverAuthorizeTooltip>
                    )}
                </Dropdown.Menu>
            </Dropdown>
            <DefaultModal
                modalShow={showDeleteModal}
                setModalShow={setShowDeleteModal}
                modalType="dlt"
                modalContent={DELETE_CHART_MESSAGE()}
                deleteFunction={handleDeletePanel}
            />
            <DownloadModal
                show={showDownloadModal}
                panel={panel}
                onClose={closeDownloadModal}
                deviceConfig={deviceConfig}
            />
        </>
    );
};

export default ChartActionDropdown;
